import React, { createContext, useContext, useEffect, useState } from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import {HeaderAnswerComponent} from "../PanelContents/HeaderAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import { RenewalLoadingSegment, RenewalLoginSegment } from '../PanelContents/RenewalSupportingSegments';
import ZooPassFetch from '../../Utilities/ZooPassFetch';
import DataFormComponent from '../PanelContents/DataFormComponent';
import ZooPassLocalStateData from '../../Data/ZooPassLocalStateData';
import ZooPassStepDataUtility from '../../Utilities/ZooPassStepDataUtility';
import ZooPass from '../../../MyAccount/Tabs/ZooPass';



export const Step3Panel : React.FC = () => {
    let {
        headerAnswers,
        textTitles,
        loading,
        memberShipDetails
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    const handleValueClick = (value : 1 | 2) => {
        if(answersData != null){
            let data: ZooPassLocalStateData = { ...answersData, step3Value: value };
            
            // Clear out any data from future steps if the step value is changes
            if(answersData.step3Value != value){
                data.step5Value = null;
                data.step6Value = 1;
            }

            data = ZooPassLocalStateUtility.SetLocalState(data);
            updateContext({type: "setAnswers", value: data});
        }
    };

    const handleRadioKeyPress = (event : any, value : 1 | 2) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleValueClick(value);
        }
    };
    
    const handleLoginClick = () => {
        console.log("Login Click");
        ZooPassFetch.redirectTNewLogin(window.baseApiUrl);
    };
    
    const handleContinue = () => {
        if (answersData != null && ZooPassStepDataUtility.IsFormDataValid(answersData.formData, answersData.step3Value == 2, answersData.step1Value == 1) && answersData.step3Value) {
            // Add logic here to proceed to the next step or perform any other action
            answersData.previousStep = answersData.step;
            if(answersData.step2Value == 1 && answersData.step1Value == 0){
                answersData.step = 7;
            }
            else {
                answersData.step = 4;
            }
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({type: "setAnswers", value: answersData});
        }
    }
    
    return !answersLoading && !loading && 
        textTitles !== null &&
        answersData !== null && headerAnswers !== null && answersData.step == 3 && (
        <div className="container d-block">
            
            {/* If renewing, show loading or login if needed */}
            {!memberShipDetails && <RenewalLoadingSegment />}
            {memberShipDetails?.isLoggedIn === false && <RenewalLoginSegment clickCallback={handleLoginClick} titleName='ZooPass:PageContent:02:Continue:Login' />}
            {/* Only show options if not gift or if logged in */}
            {(memberShipDetails?.isLoggedIn === true) && <>
                <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:03")}/>
                <div className="row g-4 mx-auto row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 justify-content-center w-auto">
                    <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:03:1")} nameValue="step3"
                                        onKeyPressEnter={(event) => handleRadioKeyPress(event, 1)}
                                        onClick={() => handleValueClick(1)} key="1" selected={answersData.step3Value == 1} />
                    <HeaderAnswerComponent headerAnswerData={headerAnswers.get("ZooPass:PageAnswer:03:2")} nameValue="step3"
                                        onKeyPressEnter={(event) => handleRadioKeyPress(event, 2)}
                                        onClick={() => handleValueClick(2)} key="2" selected={answersData.step3Value == 2} />
                </div>

                <DataFormComponent />
                {answersData?.step3Value && 
                <div style={{textAlign: 'right', maxWidth: '600px', margin: '0 auto'}}>
                    <button className="btn btn-success mt-4" onClick={() => handleContinue()} disabled={!ZooPassStepDataUtility.IsFormDataValid(answersData.formData, answersData.step3Value == 2, answersData.step1Value == 1) && !(!answersData?.step3Value)}>Continue</button>
                </div>}
            </>}
        </div>
    );
};

